/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */

export default [
    {
        path: '/?_f=prefsApi&do=gentoken&id=:id&owner_id=:owner_id',
        name: 'legacy.api.token.gen',
    },
    {
        path: '/?_f=prefsApi&do=regentoken&id=:id&type=:type',
        name: 'legacy.api.token.regen',
    },
]